import { useAtomValue } from 'jotai/react';

import { useExtensionPermissions } from '@/api/use-extension-permissions';
import { authenticatedAtom } from '@/lib/store';

export type AppMode = 'loading' | 'webrtc' | 'desktop';

export const useMode = (): AppMode => {
  const isAuthenticated = useAtomValue(authenticatedAtom);
  const {
    data,
    isLoading: isExtensionPermissionsLoading,
    isError: isExtensionPermissionsError,
  } = useExtensionPermissions();

  // Without permissions the mode is unknown; keep loading rather than assume WebRTC.
  if (
    !isAuthenticated ||
    isExtensionPermissionsLoading ||
    (isExtensionPermissionsError && !data)
  )
    return 'loading';
  return data?.hitphoneDesktopIntegration ? 'desktop' : 'webrtc';
};
